// extracted by mini-css-extract-plugin
module.exports = {"content":"PaymentModal_content__2W1d4","specifics":"PaymentModal_specifics__1V3ya"};